module.exports = __webpack_public_path__ + "img/IMG_1899_L.15ebc1b1.webp";